import DialogTag from './dialog-tag.vue'
export default DialogTag



// WEBPACK FOOTER //
// ./src/components/dialog-tag/index.js